import { ReportingWrapper } from '../../components'

export default function ReportingPage() {
  return <ReportingWrapper />
}
